// extracted by mini-css-extract-plugin
export default {"list":"Images_list__1j06Q","item":"Images_item__3RU9a","next":"Images_next__2AUp5","previous":"Images_previous__2c_sJ","on":"Images_on__1_crx","root":"Images_root__1Q3-P"};